import React from "react";

export const CardCertIca = (props) => {
  const values = props.item;
  const minMonth = values?.period?.split("-")[0];
  const maxMonth = values?.period?.split("-")[1];

  return (
    <div
      className="card card-danger card-outline"
      style={{ cursor: "pointer" }}
    >
      <div
        className="card-body"
      >
        <h6 className="font-weight-bold mb-4">{props.titulo}</h6>
        <div>
          <div className="row">
            <div className="col-12 col-md-12">
              <span className="font-weight-bold">PERIODO</span>
              <p className="text-uppercase font-xs">
                {minMonth} - {maxMonth}
              </p>
            </div>
            <div className="col-12 col-md-6">
              <span className="font-weight-bold">VIGENCIA</span>
              <p className="text-uppercase font-xs">{values.vigencia}</p>
            </div>
            {values.nom_ciudad && (
              <div className="col-12 col-md-3">
                <span className="font-weight-bold">CIUDAD</span>
                <p className="font-xs">{values.nom_ciudad}</p>
              </div>
            )}
            {/*  
              {values.invoice && (
                <div className='col-12 col-md-6'>
                  <span className='font-weight-bold'>INVOICE</span>
                  <p className='font-xs'>{values.invoice}</p>
                </div>
              )} 
            */}
            <div className="col-12 col-md-3">
              <button 
                type="button" 
                className="btn btn-danger font-weight-bold rounded-sm border-0 float-right btn-lg"
                onClick={() => {
                  props.getCertificado(values);
                }}
              >
                <i className="fa fa-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
